import { TextInput } from "react-admin";
import React from "react";
import { useField } from "react-final-form";
import {
  emailNoRequiredValidation,
  emailValidation,
} from "../utils/validation";

interface IEmailInput {
  label: string;
  source: string;
  isNullable?: boolean;
}

const EmailInput = ({ label, source, isNullable }: IEmailInput) => {
  const {
    input: { onChange },
  } = useField(source);

  return (
    <TextInput
      label={label}
      source={source}
      onChange={(e: any) => {
        const string: string = e.target.value;
        onChange(string.toLowerCase());
      }}
      type="email"
      validate={isNullable ? emailNoRequiredValidation : emailValidation}
    />
  );
};

export default EmailInput;
